export function JustifyEndIcon() {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4583 4.99967H3.45829V7.49967H13.4583V4.99967ZM3.45829 3.33301C2.53782 3.33301 1.79163 4.0792 1.79163 4.99967V7.49967C1.79163 8.42015 2.53782 9.16634 3.45829 9.16634H13.4583C14.3788 9.16634 15.125 8.42015 15.125 7.49967V4.99967C15.125 4.0792 14.3788 3.33301 13.4583 3.33301H3.45829Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4583 12.4997H6.79167L6.79167 14.9997H13.4583V12.4997ZM6.79167 10.833C5.87119 10.833 5.125 11.5792 5.125 12.4997V14.9997C5.125 15.9201 5.87119 16.6663 6.79167 16.6663H13.4583C14.3788 16.6663 15.125 15.9201 15.125 14.9997V12.4997C15.125 11.5792 14.3788 10.833 13.4583 10.833H6.79167Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.625 0.833008C18.0852 0.833008 18.4583 1.2061 18.4583 1.66634V18.333C18.4583 18.7932 18.0852 19.1663 17.625 19.1663C17.1647 19.1663 16.7916 18.7932 16.7916 18.333V1.66634C16.7916 1.2061 17.1647 0.833008 17.625 0.833008Z"
        fill="currentColor"
      />
    </svg>
  );
}
